import { ApiUrls } from '@/service/constants/urls';
import { instance } from '../Axios';
import { TAddCartApiParams } from '@/domain/Cart.domain';

export const getTipsApi = async ({
    id,
    partnerId,
}: TAddCartApiParams): Promise<{ total: number }> =>
    instance.get(`${ApiUrls.tips.root}/${id}`, { params: { partnerId } }).then(({ data }) => data);
